import Tooltip from "@mui/material/Tooltip";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useNavigate, useLocation } from "react-router-dom";
import { IconButton } from "@mui/material";

export default function RefreshBtn() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <Tooltip title="Refresh">
      <IconButton
        sx={{ color: "#2980d7" }}
        onClick={() => navigate(pathname, { replace: true })}
      >
        <RefreshIcon />
      </IconButton>
    </Tooltip>
  );
}
